import { capitalize } from "lodash";

import { useTranslate } from "@similarweb/i18n-provider";

import { swSettings } from "app/common/services/swSettings";
import { MarketingModals } from "app/components/modals/marketing-modals/MarketingModals";
import { UpgradeCta } from "app/pages/digital-suite/home-page/components/UpgradeCta";
import { AssetsService } from "app/services/AssetsService";
import { goToPackagesPage } from "app/UtilitiesAndConstants/UtilityFunctions/goToPackagesPage";
import { isNoTouch } from "app/UtilitiesAndConstants/UtilityFunctions/usersUtils";
import { AutocompleteDigitalMarketing } from "pro-features/components/AutocompleteDigitalMarketing/AutocompleteDigitalMarketing";

import { MajorNavigationTile } from "./components/MajorNavigationTile";
import { basicReportsForAEOSolution, basicReportsForAfterTrial, navigationTiles } from "./constants";
import {
    PageContainer,
    TilesGroup,
    HeaderContentContainer,
    AutocompleteWrapper,
    HeaderTitle,
    HeaderSubtitle,
    TilesContainer,
    HeaderTitleRow,
    AEOHomepageBodyTextStyled,
    AEOHomepageHeaderStyled,
    AEOBodyMargin,
} from "./styledComponents";
import { allTrackers } from "app/services/track/track";

const headerImageUrl = AssetsService.assetUrl("/images/secondary-home-page-header-light-small.png");

export const AeoHomePage = () => {
    const { translate } = useTranslate();
    const userFirstName = capitalize(swSettings?.user?.firstname as string);
    const basicReportsForAfterTrialKeys = basicReportsForAfterTrial.map((b) => b.id);
    const isNT = isNoTouch(swSettings);

    const onTileClick = (title: string): void => {
        allTrackers.dispatchTrackEvent("Internal Link", "click", `Hook PRO/homepage/${translate(title) || ""}`);

        goToPackagesPage();
    };

    return (
        <PageContainer className="main-homepage-container">
            <MarketingModals />
            {/* @ts-expect-error - bgColor is not defined on the type (should be optional in ui-components) */}
            <AEOHomepageHeaderStyled imageUrl={headerImageUrl}>
                <HeaderContentContainer>
                    <div>
                        <HeaderTitleRow>
                            <HeaderTitle>
                                {translate("aftertrial.homepage.header.title", {
                                    name: userFirstName,
                                })}
                            </HeaderTitle>
                        </HeaderTitleRow>
                        <HeaderSubtitle>{translate("digitalmarketing.homepage.header.subtitle")}</HeaderSubtitle>
                    </div>
                    <AutocompleteWrapper>
                        <AutocompleteDigitalMarketing
                            includeKeywordsData={false}
                            maxCompareItemsToDisplay={1}
                        />
                    </AutocompleteWrapper>
                </HeaderContentContainer>
            </AEOHomepageHeaderStyled>
            <TilesGroup>
                {!isNT ? (
                    <AEOHomepageBodyTextStyled>
                        {translate("aftertrial.homepage.featured.free.tiles.title")}
                    </AEOHomepageBodyTextStyled>
                ) : (
                    <AEOBodyMargin />
                )}
                <TilesContainer tilesPerRow={4}>
                    {basicReportsForAEOSolution.map((tile) => (
                        <MajorNavigationTile
                            key={tile.title}
                            {...tile}
                            guid={"after-trial-homepage.tile.click"}
                            boxHeight={198}
                        />
                    ))}
                </TilesContainer>
            </TilesGroup>
            <TilesGroup>
                <AEOHomepageBodyTextStyled>
                    {translate("aftertrial.homepage.featured.tiles.title")}
                </AEOHomepageBodyTextStyled>
                <TilesContainer tilesPerRow={4}>
                    {navigationTiles
                        .filter((t) => !basicReportsForAfterTrialKeys.includes(t.id))
                        .map((tile) => (
                            <MajorNavigationTile
                                key={tile.title}
                                {...tile}
                                boxHeight={200}
                                guid="after-trial-homepage.tile.click"
                                CtaComponent={UpgradeCta()}
                                onTileClick={onTileClick}
                            />
                        ))}
                </TilesContainer>
            </TilesGroup>
        </PageContainer>
    );
};
